import { styled, Box } from "@mui/material";

export const EmptyFolderContainer = styled(Box)({
    width: "100%",
    height: '100%',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});